// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

nz-content {
  flex: 1 0 auto;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/listings-layout/listings-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\nnz-content {\n  flex: 1 0 auto;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
